import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const ICONS = {
  facebook: () => ( <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg> ),
  x: () => ( <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg> ),
  instagram: () => ( <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg> ),
  tiktok: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF" width="24px" height="24px" viewBox="0 0 0.72 0.72" id="tiktok" data-name="Flat Color"><path id="primary" d="M0.63 0.21v0.06a0.03 0.03 0 0 1 -0.03 0.03 0.24 0.24 0 0 1 -0.12 -0.032v0.197a0.195 0.195 0 1 1 -0.284 -0.173 0.03 0.03 0 0 1 0.044 0.027v0.076a0.028 0.028 0 0 1 -0.008 0.019 0.075 0.075 0 0 0 0.06 0.127A0.078 0.078 0 0 0 0.36 0.46V0.09a0.03 0.03 0 0 1 0.03 -0.03h0.063a0.03 0.03 0 0 1 0.03 0.025A0.12 0.12 0 0 0 0.6 0.18a0.03 0.03 0 0 1 0.03 0.03" style={{fill: 'rgb(255, 255, 255)'}}/></svg>
  )
}

const Footer = ({ siteMeta }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  const [isVisible, setIsVisible] = useState(false);
  const currentYear = new Date().getFullYear();

  const socialLinks = siteMeta?.socialLinks || [];

  // Figyeli a görgetést és megjeleníti a gombot
  useEffect(() => {
    const toggleVisibility = () => {
      // A home-wrapper létezik-e (csak a főoldalon van)
      const scrollableElement = document.querySelector('.home-wrapper');
      const scrollTop = scrollableElement ? scrollableElement.scrollTop : window.scrollY;

      if (scrollTop > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    
    const scrollTarget = document.querySelector('.home-wrapper') || window;
    scrollTarget.addEventListener('scroll', toggleVisibility);

    return () => scrollTarget.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Visszagörget a tetejére
  const scrollToTop = () => {
    const scrollableElement = document.querySelector('.home-wrapper') || window;
    scrollableElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if(isAdminRoute) return null;

  return (
    <>
      <footer className="footer-container">
        <div className="footer-content">
          <div className="footer-copyright">
            © {currentYear} Logan Reid <span className="accent">Parker</span>
          </div>
          <nav className="footer-nav">
            <Link to="/rolam">Rólam</Link>
            <Link to="/letoltesek">Könyvek</Link>
            <Link to="/kapcsolat">Kapcsolat</Link>
          </nav>
          <div className="footer-socials">
            {socialLinks.filter(link => link.enabled).map(link => {
              const IconComponent = ICONS[link.platform.toLowerCase()];
              return IconComponent ? (
                <a
                  key={link.id}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.platform}
                >
                  <IconComponent />
                </a>
              ) : null;
            })}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;